<template>
  <div class="members" data-locator="participants-page">
    <MembersHeader v-model:searchQuery="searchQuery"
                   :mnemo="roomMnemo"
                   @onAddGroup="openAddGroupDialog"
    />

    <template v-if="loading || groups.length === 0">
      <v-row>
        <v-col v-for="_ in 4" :key="_" cols="3">
          <v-skeleton-loader type="text, heading@2"/>
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <v-row>
        <v-col v-for="group in filteredGroups"
               :key="`group-${group.id}`"
               cols="12"
               sm="6"
               md="4"
               lg="3"
               xl="2"
        >
          <Group :group="group" :mnemo="roomMnemo"/>
        </v-col>
        <v-col v-if="isPm"
               cols="12"
               sm="6"
               md="4"
               lg="3"
               xl="2"
        >
          <v-btn variant="flat"
                 color="#e8ebf0"
                 class="add-group-box rounded-lg text-tertiary"
                 :min-height="$vuetify.display.xs ? '80px' : '200px'"
                 data-locator="add-group-secondary-button"
                 @click="openAddGroupDialog"
          >
            <font-awesome-icon :icon="['fas', 'plus-circle']" class="mr-2" />
            {{ $t('project.members.Members.addGroup') }}
          </v-btn>
        </v-col>
      </v-row>
    </template>

    <MembersAddGroupDialog v-if="addGroupDialogIsOpen" @close="closeAddGroupDialog" />
  </div>
</template>

<script>
import { cloneDeep } from 'lodash-es'
import { mapActions, mapGetters, mapState } from 'vuex'

import MembersAddGroupDialog from './dialogs/MembersAddGroupDialog.vue'
import Group from './Group.vue'
import MembersHeader from './MembersHeader.vue'

export default {
  name: 'Members',
  components: {
    Group,
    MembersAddGroupDialog,
    MembersHeader,
  },
  data () {
    return {
      addGroupDialogIsOpen: false,
      hideMembersDialogIsOpen: false,
      searchQuery: '',
    }
  },
  head () {
    return {
      title: this.$t('project.members.Members.metaTitle'),
    }
  },
  computed: {
    ...mapState('groups', ['groups', 'loading']),
    ...mapGetters('room', ['roomMnemo']),
    isPm () {
      return this.$store.getters['room/isCurrentUserPm']
    },
    filteredGroups () {
      const filteredGroups = cloneDeep(this.groups)

      if (this.searchQuery) {
        const query = this.searchQuery.toLowerCase()
        filteredGroups.forEach(group => {
          group.members = group.members.filter(member =>
            member.fullName.toLowerCase().includes(query) ||
            member.company.toLowerCase().includes(query))
        })
      }
      return filteredGroups
    },
  },
  mounted () {
    this.GET_GROUPS(this.roomMnemo)
  },
  methods: {
    ...mapActions('groups', ['GET_GROUPS']),
    openAddGroupDialog () {
      this.addGroupDialogIsOpen = true
    },
    closeAddGroupDialog () {
      this.addGroupDialogIsOpen = false
    },
  },
}
</script>

<style lang="scss" scoped>
.add-group-box {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
</style>
